import { create, StateCreator } from 'zustand'

interface IFullScreenModeState {
  isFullScreenMode: boolean
  setIsFullScreenMode: (isFullScreenMode: boolean) => void
}

const createFullScreenModeStore: StateCreator<IFullScreenModeState> = (
  set,
) => ({
  isFullScreenMode: false,
  setIsFullScreenMode: (isFullScreenMode: boolean) => set({ isFullScreenMode }),
})

export const useFullScreenModeStore = create<IFullScreenModeState>(
  createFullScreenModeStore,
)
